import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import React from "react";
import { WidgetProps } from "./models";

interface SwitchWidgetProps extends WidgetProps<boolean> {}

export const SwitchWidgetComponent = (props: SwitchWidgetProps) => {
  const { id, value, disabled, label, onChange, onBlur, onFocus } = props;

  const handleChange = (event: any) => onChange(event.target.checked as boolean);
  const handleBlur = onBlur && ((event: any) => onBlur(id, value));
  const handleFocus = onFocus && ((event: any) => onFocus(id, value));

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          aria-label={`checked-${id}`}
        />
      }
      label={label}
      style={{ width: "100%" }}
    />
  );
};

export const SwitchWidget = SwitchWidgetComponent;
